import XIconRemoveButton from "components/buttons/XIconRemoveButton";
import React from "react";

interface Props<TValue> {
  title: string
  removeFilter: () => void
  renderTemplate: () => JSX.Element
  value: TValue
  showTitle: boolean
}

const SelectedFilter = <TValue extends unknown>(props: Props<TValue>) => {
  return <div className="filter_row">
    <XIconRemoveButton
      group="removeFilter"
      onClick={() => { props.removeFilter(); }}
    />

    {props.showTitle && <div className="s1_gray" style={{ whiteSpace: "nowrap" }}>
      {props.title}
    </div>}

    <div className="filter_list">
      {props.renderTemplate()}
    </div>
  </div>;
};

export default SelectedFilter;